import Vue from 'vue';
// @ts-ignore
import { mixin as clickaway } from 'vue-clickaway';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { AUTOCOMPLETE_GET_SUGGESTIONS, AUTOCOMPLETE_SET_SUGGESTIONS } from '../stores/autocomplete';
import { AutocompleteInput, AutocompleteSuggestion } from '../models/Autocomplete';

@Component({
    name: 'Autocomplete',
    mixins: [clickaway],
})
export default class Autocomplete extends Vue {
  @Prop() addBtnLabel!: string;

  @Prop() sug!: string;

  focus: number = -1;

  @Prop({
      default: true,
  }) showAddBtn!: boolean;

  @Prop({
      default: '',
  }) inputClass!: string;

  inputVal: any = [];

  inputChangedByOnSuggestionSelected = false;

  get suggestions(): AutocompleteSuggestion[] {
      return this.$store.getters[AUTOCOMPLETE_GET_SUGGESTIONS]
          .filter((s: AutocompleteSuggestion) => s.Id !== this.$attrs['id'])
          .map((s: AutocompleteSuggestion) => s);
  }

  @Watch('inputVal')
  onInputValChanged(nv: string, ov: string) {
      if (nv === ov) return;
      // Prevent sending an event which would casue the
      // suggested list to update, which we don't want.
      if (this.inputChangedByOnSuggestionSelected) {
          this.inputChangedByOnSuggestionSelected = false;
          this.focus = 0;
          return;
      }
      this.$emit('onTyping', new AutocompleteInput(this.$attrs['id'], nv));
      if (nv.length === 0) {
          this.$store.commit(AUTOCOMPLETE_SET_SUGGESTIONS, []);
          this.focus = 0;
      }
  }

  onSuggestionSelected(item: AutocompleteSuggestion): void {
      this.inputChangedByOnSuggestionSelected = true;
      this.inputVal = item;
      this.$emit('suggestionSelected', item);
      this.$store.commit(AUTOCOMPLETE_SET_SUGGESTIONS, []);
      this.$emit('addItemClicked', item);
      this.inputVal = [];
  }

  onAddItem(): void {
      this.$emit('addItemClicked', this.inputVal);
      this.inputVal = '';
  }

  onBlur(): void {
      // Give time for a onSuggestionSelected to be handled
      // before we start doing our thing here
      setTimeout(() => {
          this.$emit('suggestionSelected', this.inputVal);
          this.$store.commit(AUTOCOMPLETE_SET_SUGGESTIONS, []);
      }, 500);
      this.focus = -1;
  }

  reset(): void {
      this.inputVal = '';
      this.focus = -1;
      this.$store.commit(AUTOCOMPLETE_SET_SUGGESTIONS, []);
      // @ts-ignore
      this.$refs.calAutocompleteInput.focus();
  }

  test(event: any): any {
      let elm: any | null = null;
      switch (event.keyCode) {
      // Up
      case 38:
          if (this.focus >= 0) {
              this.focus = this.focus - 1;
          }
          if (this.focus === -1) {
          // @ts-ignore
              this.$refs.calAutocompleteInput.focus();
          } else {
          // @ts-ignore
              elm = (this.$refs[`scrollId-${this.focus}`] && this.$refs[`scrollId-${this.focus}`].length)
              // @ts-ignore
                  ? this.$refs[`scrollId-${this.focus}`][0]
                  : null;
              if (elm) {
                  // @ts-ignore
                  elm.focus();
              }
          }
          event.preventDefault();
          break;
      // Down
      case 40:
          if (this.focus < this.suggestions.length - 1) {
              this.focus = this.focus + 1;
          // idScroll.scrollIntoView({ block: 'start', inline: 'nearest' });
          }
          // @ts-ignore
          elm = (this.$refs[`scrollId-${this.focus}`] && this.$refs[`scrollId-${this.focus}`].length)
          // @ts-ignore
              ? this.$refs[`scrollId-${this.focus}`][0]
              : null;
          if (elm) {
          // @ts-ignore
              elm.focus();
              event.preventDefault();
          }
          break;
      // Enter
      case 13:
          if (this.focus >= 0) {
              this.onSuggestionSelected(this.suggestions[this.focus]);
              this.focus = 0;
          }
          break;
      case 27:
          this.reset();
          break;
      default:
          break;
      }
  }
}
